import { Component, forwardRef, ViewChild } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { InputBase } from "../input-base";

@Component({
    selector: "hcc-number-input-custom",
    templateUrl: "./number-input-custom.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumberInputCustomComponent),
            multi: true
        }
    ],
    standalone: false
})
export class NumberInputCustomComponent extends InputBase<string> {
  constructor() {
    super();
  }
}
